<template>
  <div id="app">
    <!--<AppHeader></AppHeader>
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> |
      <router-link to="/publishers/Martin">Publisher</router-link> |
      <router-link to="/publishers/FQCK/maps/st_charles?q=abc">St-Charles</router-link> |
    </div>-->

    <div id="content">
      <router-view/>
    </div>
  </div>
</template>

<script>
import AuthenticationService from '@/service/AuthenticationService'
import router from './router'

export default {
  components: {
//    AppHeader    
  },
  mounted() {
      const authenticationService = new AuthenticationService(this.$store);
      authenticationService.initialize();

      const webViewerPublisherId = document.documentElement.getAttribute("ondago_webviewer_publisherId");
      const webViewerMapId = document.documentElement.getAttribute("ondago_webviewer_mapId");
      if (webViewerPublisherId && webViewerMapId) {
          console.log("navigating " + webViewerPublisherId + " " + webViewerMapId);
          router.replace({ 
              path: "/webviewers/" + webViewerPublisherId + "/maps/" + webViewerMapId + "?format=list"
          });
      }
  }
}
</script>

<style lang="scss">
@media (prefers-color-scheme: dark) {
    :root {
        color-scheme: light;
    }
}

/* Chrome */
@media (forced-colors: active) {
    :root {
        color-scheme: light;
    }
}

html, body {
  height: 100%;
  margin: 0;
}

#app {
  display: flex;
  flex-flow: column;
  height: 100%;

  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#content {
  display: flex;
  flex: 1 1 auto;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

form .row div {
  background-color: #eeeeee;
}
</style>
